import React from 'react';
import './About.css';
import aboutPreview from '../../assets/images/about-preview.jpg';

const About: React.FC = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-mockup">
          <div className="about-phone">
            <img
              src={aboutPreview}
              alt="Gelwel App Preview"
              className="about-phone-image"
            />
          </div>
        </div>
        <div className="about-content">
          <h2 className="about-heading">What is Gelwel?</h2>
          <p className="about-description">
            Gelwel is the ultimate social and lifestyle app designed for the modern generation.
            Connect authentically, discover new friends who match your vibe, and share your
            lifestyle with a community that truly gets you.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
